import { translate } from "@/plugins/i18n";
import type BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";
import { Maybe } from "@/components/utils/typeHelpers";


export class EnumSmsContext implements BaseEnumType {
  private static allValues: EnumSmsContext[] = []; // make sure this is top-most
  
  public static unknown = new EnumSmsContext(0, "Unknown", "enum_sms_context_unknown");
  public static despatchNotification = new EnumSmsContext(1, "DespatchNotification", "enum_sms_context_despatch_notification");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumSmsContext.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isUnknown() { return this === EnumSmsContext.unknown; }
  public isDespatchNotification() { return this === EnumSmsContext.despatchNotification; }

  public static getValues(): readonly EnumSmsContext[] {
    return EnumSmsContext.allValues;
  }

  public static getValuesExcept0(): readonly EnumSmsContext[] {
    return EnumSmsContext.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumSmsContext {
    const found = EnumSmsContext.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumSmsContext - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumSmsContext): EnumSmsContext {
    const found = name ? EnumSmsContext.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumSmsContext - Value not found: ${ name }`);
    }

    return found;
  }

  public equals(other: Maybe<EnumSmsContext>): boolean {
    return this.key === other?.key;
  }
}